/**
 * Đọc số tiền bằng chữ tiếng Việt
 * E.g. 1,234,500 → "Một triệu hai trăm ba mươi bốn nghìn năm trăm đồng"
 */

const DIGITS = ['không', 'một', 'hai', 'ba', 'bốn', 'năm', 'sáu', 'bảy', 'tám', 'chín'];

function readGroup(hundreds: number, tens: number, units: number, showZeroHundred: boolean): string {
    const parts: string[] = [];

    if (hundreds > 0) {
        parts.push(DIGITS[hundreds] + ' trăm');
    } else if (showZeroHundred) {
        parts.push('không trăm');
    }

    if (tens > 1) {
        parts.push(DIGITS[tens] + ' mươi');
        if (units === 1) parts.push('mốt');
        else if (units === 5) parts.push('lăm');
        else if (units > 0) parts.push(DIGITS[units]);
    } else if (tens === 1) {
        parts.push('mười');
        if (units === 5) parts.push('lăm');
        else if (units > 0) parts.push(DIGITS[units]);
    } else if (units > 0) {
        if (showZeroHundred || hundreds > 0) parts.push('lẻ');
        parts.push(DIGITS[units]);
    }

    return parts.join(' ');
}

export function numberToVietnameseWords(n: number, currency: string = 'đồng'): string {
    if (n === 0) return `Không ${currency}`;

    const num = Math.round(Math.abs(n));
    const numStr = String(num);

    // Split into groups of 3 from right
    const groups: number[][] = [];
    let i = numStr.length;
    while (i > 0) {
        const start = Math.max(0, i - 3);
        const slice = numStr.slice(start, i);
        const digits = slice.split('').map(Number);
        while (digits.length < 3) digits.unshift(0);
        groups.unshift(digits);
        i = start;
    }

    const UNITS = ['', 'nghìn', 'triệu', 'tỷ', 'nghìn tỷ', 'triệu tỷ'];

    const parts: string[] = [];
    for (let g = 0; g < groups.length; g++) {
        const [h, t, u] = groups[g];
        const unitIndex = groups.length - 1 - g;
        const showZero = g > 0 && (h > 0 || t > 0 || u > 0); // show "không trăm" for middle groups
        const groupText = readGroup(h, t, u, showZero);
        if (groupText) {
            parts.push(groupText + (UNITS[unitIndex] ? ' ' + UNITS[unitIndex] : ''));
        }
    }

    const result = parts.join(' ');
    const capitalized = result.charAt(0).toUpperCase() + result.slice(1);
    return n < 0 ? `Âm ${capitalized} ${currency}` : `${capitalized} ${currency}`;
}
